import React, { useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import AnalyticsDrilldownModal from "./AnalyticsDrilldownModal";

const RepeatTrendChart = ({ data, filters }) => {
    const [drilldownInfo, setDrilldownInfo] = useState({ isOpen: false, month: null, title: "" });

    if (!data) return <div>Loading Trends...</div>;

    const categories = data.map(d => d.month);
    const companyReopens = data.map(d => parseInt(d.company_reopens, 10));
    const avgEmployee = data.map(d => parseFloat(d.avg_per_employee));

    const options = {
        chart: {
            type: 'column',
            backgroundColor: 'transparent'
        },
        title: {
            text: 'Avg Repeat Ticket Trends',
            align: 'left',
            style: { fontWeight: '600', fontSize: '16px' }
        },
        subtitle: {
            text: 'Monthly Analysis (Company vs Avg Employee)<br/><span style="color: #666">Click on bars to see ticket details</span>'
        },
        xAxis: {
            categories: categories,
            crosshair: true
        },
        yAxis: {
            title: {
                text: 'Ticket Count'
            },
            min: 0
        },
        tooltip: {
            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b>{point.y}</b></td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
        },
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0,
                cursor: 'pointer',
                point: {
                    events: {
                        click: function () {
                            const monthData = data[this.index];
                            setDrilldownInfo({
                                isOpen: true,
                                month: monthData.month,
                                title: `Repeat Tickets in ${monthData.month}`
                            });
                        }
                    }
                }
            }
        },
        series: [{
            name: 'Company Total Reopens',
            data: companyReopens,
            color: '#dc2626', // Red
            borderRadius: 4
        }, {
            name: 'Avg Company Reopens (Per Employee)',
            data: avgEmployee,
            color: '#2563eb', // Blue
            borderRadius: 4
        }],
        credits: { enabled: false }
    };

    return (
        <div className="bg-white p-6 rounded-2xl shadow-md border border-gray-100">
            <HighchartsReact highcharts={Highcharts} options={options} />

            <AnalyticsDrilldownModal
                isOpen={drilldownInfo.isOpen}
                onClose={() => setDrilldownInfo({ ...drilldownInfo, isOpen: false })}
                title={drilldownInfo.title}
                type="repeat"
                month={drilldownInfo.month}
                filters={filters}
            />
        </div>
    );
};

export default RepeatTrendChart;
